import { Navigate } from "react-router-dom";

export function BomHomePage() {
  return <Navigate to="/bom/families" replace />;
}
